<template>
<div class="chapter">
<div class="inner_page">
<div class="basic-text-frame">
<div class="frame">
<img alt="119657.png" class="frame2" src="OEBPS/image/119657.png"/>
</div>
<div class="basic-text-frame">
<p class="bodytext"><span class="testimonial-body"></span></p>
<p class="bodytext1"><span class="testimonial-body"></span></p>
</div>
<div class="basic-text-frame">
<p class="normal"></p>
</div>
<div class="frame">
<img alt="crazy.psd" class="frame3" src="OEBPS/image/crazy_fmt.png"/>
</div>
<div class="basic-text-frame">
<p class="bodytext2"><span class="byline">Crazy Quilt Block</span></p>
</div>
<div class="frame">
<img alt="100075.png" class="frame4" src="OEBPS/image/100075.png"/>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// quilt-left-behind_split3.vue?d7ee1abe